var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elTag,{tag:"component",staticClass:"s-radio-group",class:_vm.row ? 's-radio-group-row' : 's-radio-group-column',attrs:{"data-qa":`${_vm.dataQa}-group`,"role":"radiogroup"},on:{"keydown":_vm.handleKeydown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }